import {Component, tag} from 'doz'
import Program from './program'

@tag('day')
export default class extends Component {
    /*props = {
        items: []
    };*/

    template(h) {
        return h`
            <style>

            </style>
            <div class="day">
                ${this.props.hours.map(item => h`
                    <${Program} 
                        is-today="${this.props.isToday}" 
                        mview-id="${item.mviewId}" 
                        title="${item.title}" 
                        description="${item.description || ''}" 
                        short_description="${item.short_description || ''}" 
                        image="${item.thumbnail}" 
                        hour-start="${item.hour_start}" 
                        hour-end="${item.hour_end}"
                        />
                `)}
            </div>
        `
    }

    onMountAsync() {

    }
}
